import { Request } from '../request';
import { ReminderSettings, ServiceCustomization } from 'types/calendarSetting';
import { IproviderAvailabilityList, IproviderOverrideList, IproviderOverrideCreate } from 'types/appointmentSetting';

export const providerAvailabilityList = (id: number) =>
    Request.get<IproviderAvailabilityList[]>({ url: `/schedule-server/provider/availability/listByProviderId/${id}` });
export const providerAvailabilitySave = (data: IproviderAvailabilityList, id: number) =>
    Request.post({ url: `/schedule-server/provider/availability/saveByProviderId/${id}`, params: data });

export const providerOverrideList = (id: number, scheduleToken?: string) =>
    Request.get<IproviderOverrideList[]>({
        url: `/schedule-server/provider/override/listByProviderId/?providerId=${id}`,
        scheduleToken,
    });
export const providerOverrideCreate = (data: IproviderOverrideCreate[], scheduleToken?: string) =>
    Request.post({ url: '/schedule-server/provider/override/batch/create', params: data, scheduleToken });
export const providerOverrideDelete = (ids: number[], scheduleToken?: string) =>
    Request.delete({ url: '/schedule-server/provider/override/batch/del', params: ids, scheduleToken });

export const fetchReminderSettings = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/calendar/config/reminders', scheduleToken });
export const updateReminderSettings = (data: Partial<ReminderSettings>, scheduleToken?: string) =>
    Request.post({ url: '/schedule-server/calendar/config/reminders', params: data, scheduleToken });

export const fetchServiceCustomization = () =>
    Request.get({ url: '/schedule-server/calendar/config/service/customization' });
export const updateServiceCustomization = (data: ServiceCustomization[]) =>
    Request.post({ url: '/schedule-server/calendar/config/service/customization', params: data });
